class PasswordModal extends DetailsModal {
  constructor() {
    super();

    if (this.querySelector('input[aria-invalid="true"]')) this.open({ target: this.querySelector('details') });
  }
}

customElements.define('password-modal', PasswordModal);

// Select the details element
const detailsElement = document.querySelector('.password-modal.modal');

// Select the header element
const headerElement = document.getElementById('shopify-section-main-password-header');

// Create a MutationObserver to watch for attribute changes
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
      if (detailsElement.hasAttribute('open')) {
        // Remove position: absolute when open="true"
        headerElement.style.position = 'static';
      } else {
        // Add position: absolute when open attribute is removed
        headerElement.style.position = 'absolute';
      }
    }
  });
});

// Configure and start the observer
const config = { attributes: true };
observer.observe(detailsElement, config);

// Initial check in case the details element is already open
if (detailsElement.hasAttribute('open')) {
  headerElement.style.position = 'static';
} else {
  headerElement.style.position = 'absolute';
}
